var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import { traitClass } from "../Trait";
import mixTraits from "../mixTraits";
import ArcGisPortalSharedTraits from "./ArcGisPortalSharedTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import GroupTraits from "./GroupTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import UrlTraits from "./UrlTraits";
let ArcGisPortalCatalogGroupTraits = (_dec = traitClass({
  description: "Creates a group with members from ArcGIS server portal.\n\n  <strong>Note:</strong> \n  <br>The following example will</br>\n  <li>Request datasets of specific types only.</li>\n  <li>Organise members in subgroups according to their categories.</li>\n  <li>Sort members according to their titles.</li>",
  example: {
    url: "https://portal.spatial.nsw.gov.au/portal",
    type: "arcgis-portal-group",
    groupBy: "portalCategories",
    name: "NSW Spatial Portal Categories",
    searchParams: {
      q: '(type:"Map Service" OR type:"WMS" OR type:"KML")',
      sortField: "title"
    },
    id: "some id"
  }
}), _dec2 = anyTrait({
  name: "Search Parameters",
  description: "An object containing parameters matching the ArcGIS Rest API params, see https://developers.arcgis.com/rest/users-groups-and-items/search-reference.htm"
}), _dec3 = anyTrait({
  name: "Group Search Parameters",
  description: "An object containing parameters to search by groups using the ArcGIS Rest API params, see https://developers.arcgis.com/rest/users-groups-and-items/group-search.htm\n    Note: this setting is only used when \"groupBy\" option is set to \"organisationsGroups\".\n    "
}), _dec4 = primitiveTrait({
  type: "string",
  name: "Group By",
  description: "Gets or sets a value indicating how datasets should be grouped.  Valid values are:\n     * none - All available datasets are put in a flat list; they are not grouped at all.\n     * organisationsGroups - Data is retrieved and sorted by the organisations groups.\n     * portalCategories - Data is retrieved and sorted by categories specified by the portal items.\n     * usersGroups - Data is retrieved and sorted by the groups particular to the user.\n     * Note: This requires a user to be signed into portal, with a \"portalUsername\" to be set in \"terria.userProperties\", this is not available by default and requires custom configuration of TerriaMap.\n    "
}), _dec5 = primitiveTrait({
  type: "string",
  name: "Ungrouped title",
  description: "A title for the group holding all items that don't have a group in an ArcGIS Portal.\n      If the value is a blank string or undefined, these items will be left at the top level, not grouped."
}), _dec6 = primitiveTrait({
  type: "boolean",
  name: "Hide empty groups",
  description: "If a group has no items don't display it in the catalog"
}), _dec(_class = (_class2 = class ArcGisPortalCatalogGroupTraits extends mixTraits(GroupTraits, UrlTraits, CatalogMemberTraits, LegendOwnerTraits, ArcGisPortalSharedTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "searchParams", _descriptor, this);
    _initializerDefineProperty(this, "groupSearchParams", _descriptor2, this);
    _initializerDefineProperty(this, "groupBy", _descriptor3, this);
    _initializerDefineProperty(this, "ungroupedTitle", _descriptor4, this);
    _initializerDefineProperty(this, "hideEmptyGroups", _descriptor5, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "searchParams", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      q: "(type:\"Scene Service\" OR\n         type:\"Feature Service\" OR\n         type:\"Map Service\" OR\n         type:\"WMS\" OR\n         type:\"WFS\" OR\n         type:\"KML\")",
      sortField: "title"
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "groupSearchParams", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      q: "orgid:0123456789ABCDEF\n       (access:private OR access:org)\n       -owner:esri_nav\n       -owner:esri_livingatlas\n       -owner:esri_boundaries\n       -owner:esri_demographics\n      ",
      searchUserAccess: "groupMember"
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "groupBy", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "none";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "ungroupedTitle", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "Ungrouped";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "hideEmptyGroups", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _class2)) || _class);
export { ArcGisPortalCatalogGroupTraits as default };